import { restRequest as o, REST_VERBS as r } from "@ado/base-service";
import { createRequestOptionsBuilder as a } from "../../../shared/libraries/request_options_building/index.js";
import { KnownQueryKey as n } from "../../../shared/libraries/known_query_parameters/index3.js";
const i = "/api/foundation/metadata/v1/";
function d(t) {
  const e = a().setKnownQueryParameters(n.CountryCode).setAdditionalQueryParameters(t).build();
  return o(r.GET, i + "page-metadata", e);
}
export {
  d as getPageMetadata
};
//# sourceMappingURL=index.js.map
